module.exports = __webpack_public_path__ + "static/media/sign-in-kids.2c8c1599.png";